import BaseEnum from "./base_enum.js";

class PaymentMethodTypeEnumDesc extends BaseEnum {

  name() {
    return "payment_method_type";
  }

  rawValues() {
    return ["iban"];
  }

}

const PaymentMethodTypeEnum = new PaymentMethodTypeEnumDesc();
export default PaymentMethodTypeEnum;